








import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
    name: 'Clear',
    head: {
        titleTemplate: 'Workle - %s',
        __dangerouslyDisableSanitizers: [ 'script', 'noscript' ],
        script: [
            {
                hid: 'myTracker-customer',
                innerHTML: `
                    var _tmr = window._tmr || (window._tmr = []);
                    _tmr.push({id: "3504723", type: "pageView", start: (new Date()).getTime()});
                    (function (d, w, id) {
                      if (d.getElementById(id)) return;
                      var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
                      ts.src = "https://top-fwz1.mail.ru/js/code.js";
                      var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
                      if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
                    })(document, window, "tmr-code");
                `,
                type: 'text/javascript',
                charset: 'utf-8'
            },
            {
                src: '//code.jivo.ru/widget/UD2Uzfk632',
                async: true
            },
            {
                hid: 'gtm',
                innerHTML: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-KDXVNMW4');
                `
            },
            {
                hid: 'ym-3',
                innerHTML: `
                    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                    m[i].l=1*new Date();
                    for (var j = 0; j < document.scripts.length; j++)
                        {if (document.scripts[j].src === r) { return; }}
                    k=e.createElement(t),
                    a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
                    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
                    ym(17882743, "init", {
                            clickmap:true,
                            trackLinks:true,
                            accurateTrackBounce:true,
                            webvisor:true,
                            trackHash:true
                    });
                `,
                type: 'text/javascript',
                charset: 'utf-8'
            },
            {
                hid: 'vwo-clear',
                innerHTML: `
                    window._vwo_code || (function() {
                    var account_id=778561,
                    version=2.0,
                    settings_tolerance=2000,
                    hide_element='body',
                    hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
                    /* DO NOT EDIT BELOW THIS LINE */
                    f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();
                `,
                type: 'text/javascript',
                charset: 'utf-8'
            }
        ],
        noscript: [
            {
                hid: 'meTracker',
                innerHTML: `
                    <div>
                        <img
                            src="https://top-fwz1.mail.ru/counter?id=3504723;js=na"
                            style="position:absolute;left:-9999px;"
                            alt="Top.Mail.Ru"
                        />
                    </div>
                `
            },
            {
                hid: 'gtm',
                innerHTML: `
                    <iframe
                        src="https://www.googletagmanager.com/ns.html?id=GTM-KDXVNMW4"
                        height="0"
                        width="0"
                        style="display:none; visibility:hidden"
                    ></iframe>
                `
            },
            {
                hid: 'ym-4',
                innerHTML: `
                    <div>
                        <img
                            src="https://mc.yandex.ru/watch/17882743"
                            style="position:absolute; left:-9999px;" alt=""
                        />
                    </div>`
            }
        ]
    }
})
